import { Dispatch, SetStateAction, useEffect } from 'react';

export function useSetSeemoreVisibility(
  setShowSeeMore: Dispatch<SetStateAction<boolean>>,
  itemsLimit?: number,
  itemsLength?: number
) {
  useEffect(() => {
    if (itemsLength && itemsLimit && itemsLength > itemsLimit) {
      setShowSeeMore(true);
    } else {
      setShowSeeMore(false);
    }
  }, [itemsLength, setShowSeeMore, itemsLimit]);
}
